import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export function CurrencyCounterSkeleton() {
  return (
    <div
      style={{ justifyItems: 'center', marginTop: '30px', marginBottom: '30px' }}
      className="qlf-skeleton"
    >
      <Skeleton variant="circular" width={'9rem'} height={'9rem'} />
      <Skeleton
        variant="rectangular"
        width={'6rem'}
        height={'3rem'}
        sx={{ marginTop: '5px', borderRadius: 2 }}
      />
      <Skeleton variant="text" width={'8rem'} sx={{ fontSize: '2rem' }} />
    </div>
  );
}
